import { combineReducers } from 'redux';
import apiCallsInProgress from './apiStatusReducer';
import facilities from './facilitiesReducer';
import projects from './projectsReducer';

const rootReducer = combineReducers({
    apiCallsInProgress,
    facilities,
    projects
});

export default rootReducer;